import React from 'react';
import { BOLT_ICON_URL } from '../constants';

export const BoltIcon = () => (
  <img
    src={BOLT_ICON_URL}
    alt="bolt"
    width="16"
    height="16"
    data-testid="bolt-icon"
  />
);

BoltIcon.displayName = 'BoltIcon';
